import { render, staticRenderFns } from "./sponsers.vue?vue&type=template&id=4f803a60&scoped=true&"
import script from "./sponsers.vue?vue&type=script&lang=js&"
export * from "./sponsers.vue?vue&type=script&lang=js&"
import style0 from "./sponsers.vue?vue&type=style&index=0&id=4f803a60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f803a60",
  null
  
)

component.options.__file = "sponsers.vue"
export default component.exports